import { memo, useRef } from 'react';

import { AlertModal, AlertModalCloseButton, AlertModalDescription, AlertModalTitle } from '@air/primitive-alert-modal';
import { Button } from '@air/primitive-button';

export type MaxFolderDepthModalProps = {
  onClose: () => void;
};

export const MaxFolderDepthModal = memo(({ onClose }: MaxFolderDepthModalProps) => {
  const leastDestructiveRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertModal isOpen onDismiss={onClose} leastDestructiveRef={leastDestructiveRef}>
      <div className="mb-3 flex justify-between">
        <AlertModalTitle>Maximum folder depth reached</AlertModalTitle>
        <AlertModalCloseButton className="shrink-0" onClick={onClose} />
      </div>
      <AlertModalDescription className="pt-1 pb-2">
        Your folder structure has too many nested levels, reaching the maximum limit of 30. To continue, try simplifying
        your folder structure and re-upload
      </AlertModalDescription>

      <div className="-mx-6 -mb-6 flex justify-end gap-3 px-6 py-4">
        <Button appearance="filled" color="blue" onClick={onClose} ref={leastDestructiveRef} size="large">
          Continue
        </Button>
      </div>
    </AlertModal>
  );
});

MaxFolderDepthModal.displayName = 'MaxFolderDepthModal';
